const p4 = require('./p4.js')
const p5 = require('./p5.js')

function comming(title) {
  return {
    title,
    author: 'gzshi',
    post: '2023-02-25 12:00',
    tags: [],
    summary: 'comming soon',
    summaryCompiler: 'md',
    more: false
  }
}

module.exports = {
  type: 'parts',
  title: '批判性思维学习笔记 Critical Thinking',
  author: 'gzshi',
  post: '2023-06-08 22:50',
  tags: ['理性', '批判性思维', 'Criticle Thinking', '方法论'],

  partIndex: 3,
  parts: [
    comming('启蒙'),
    comming('人格'),
    comming('概论'),
    p4,
    p5,
    comming('目的'),
    comming('问题'),
    comming('概念'),
    comming('信息'),
    comming('根据'),
    comming('推理'),
    comming('结论'),
    comming('预设'),
    comming('应用'),
  ]
}


// WEBPACK FOOTER //
// ./src/blog/20230608_critical_thinking/data.js